import React from 'react';
import DataCard from '../../../cards/DataCard';

class MapDataCard extends DataCard {

  // get extractType() {
  //   return 'json';
  // }

  renderData(data) {
    return (
      <div style={{height: '100%', width: '100%'}}>
        {data}
      </div>
    );
  }

}

export default MapDataCard;

